<template>
  <mi-dialog
    key="checkWhatsNewModel-dialog"
    :model-value="!!whatsNew.whatsModalNewData || previewingModal"
    class="checks-whats-new-dialog"
    no-backdrop-dismiss
    custom-design-dialog
  >
    <div class="checks-whats-new">
      <!-- Header -->
      <div class="checks-whats-new-header">
        <div>
          <h1 class="checks-whats-new-header-title q-my-sm q-px-none text-uppercase">
            Check what´s new
          </h1>
        </div>
        <mi-btn
          v-close-popup
          icon="close"
          icon-type
          icon-size="18px"
          fab
          flat
          data-cy="checks-whats-new-close"
          @click="closeWhatsNewModal"
        ></mi-btn>
      </div>
      <!-- Content -->
      <div class="checks-whats-new-content">
        <h6
          class="checks-whats-new-content--title text-uppercase"
        >
          NOW YOU CAN
        </h6>
        <div v-for="whatsNewModalData in whatsNewModalDataTopics" :key="whatsNewModalData.header" class="q-mb-lg">
          <div>
            <h6 class="checks-whats-new-content--content-title text-uppercase">
              {{ whatsNewModalData.header }}
              <mi-badge
                class="checks-whats-new-content--badge"
                label="NEW"
                rounded
              ></mi-badge>
            </h6>
            <span class="checks-whats-new-content--content-subtitle">
              {{ whatsNewModalData.description }}
            </span>
          </div>

          <div class="row">
            <div v-for="stepData in whatsNewModalData.steps" :key="stepData.step">
              <div v-if="stepData.description || stepData.image" class="col checks-whats-new-content--step q-mt-md">
                <div v-if="stepData.image" class="checks-whats-new-content--step-image">
                  <img
                    :src="stepData.image"
                    alt="stepImage"
                    width="217"
                    height="80"
                  />
                </div>
                <div class="checks-whats-new-content--step-title"> step {{ stepData.step }}</div>
                <div class="checks-whats-new-content--step-subtitle">{{ stepData.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  import MiDialog from '@/packages/@mi-library/MiDialog/MiDialog.vue'
  import { NOTIFICATION_TYPES } from '@/constants/notifications'
  import { onMounted, inject, ref } from 'vue'
  import { useWhatsNew } from '@/components/whats-new/composables/useWhatsNew'
  import { useNotificationsState } from '@/composables/useNotificationsState'

  export default {
    name: 'CheckWhatsNewModal',
    components: { MiDialog },
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    },
    setup(props) {
      const {
        notificationsState,
        fetchNotificationsState
      } = useNotificationsState()
      const { whatsNew, fetchModalWhatsNewData } = useWhatsNew()
      const previewingModal = inject('previewingModal')
      const whatsNewModalDataTopics = ref([])

      const fetchWhatsNewContent = async () => {
        if (previewingModal) {
          whatsNewModalDataTopics.value[0] = props.data
        }
        else {
          await fetchModalWhatsNewData(notificationsState.lastSeenTimestamp)
          whatsNewModalDataTopics.value = whatsNew.whatsModalNewData
        }
      }

      const closeWhatsNewModal = async () => {
        if (!previewingModal) {
          await fetchNotificationsState({
            type: NOTIFICATION_TYPES.whatsNewModal,
            seen: true
          })
        }
        else {
          previewingModal.value = false
        }
      }

      onMounted(async () => {
        await fetchWhatsNewContent()
      })

      return {
        closeWhatsNewModal,
        whatsNew,
        fetchWhatsNewContent,
        previewingModal,
        whatsNewModalDataTopics
      }
    }
  }
</script>

<style lang="scss">
  .row > div:not(:last-child) .checks-whats-new-content--step {
    margin-right: 34px;
  }

  ul {
    margin: 0;
    padding-left: 20px;
  }

  .checks-whats-new {
    display: flex;
    flex-direction: column;
  }

  .checks-whats-new-dialog .q-dialog__inner > .mi-card {
    width: 924px;
    max-width: 924px;
    min-width: 924px;
    position: relative;
  }

  .checks-whats-new-header {
    background-color: $mi-anthracite-50;
    height: 111px;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    margin: 0;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .checks-whats-new-header-title {
    font-size: 36px;
    line-height: 56px;
    font-weight: 700;
    color: $mi-anthracite-800;
  }

  .checks-whats-new-content {
    width: 924px;
    max-width: 924px;
    min-width: 924px;
    padding: 16px 24px 64px 40px;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    &--title {
      font-size: 18px;
      font-weight: 700;
      color: $mi-red-500;
      margin: 40px 0 16px;
    }

    &--title:first-of-type {
      margin: 40px 0 16px;
    }

    &--body {
      margin: 0;
    }

    &--content-title {
      font-size: 18px;
      font-weight: 700;
      color: $mi-anthracite-800;
      margin: 0 0 1%;
      display: flex;
      gap: 8px;
    }

    &--badge {
      width: 50px;
      height: 22px;
      justify-content: center;
      flex-direction: row;
      flex-wrap: nowrap;
      border-radius: 16px;
      padding: 1px 12px;
      background: $mi-anthracite-800;
      left: 0;
      color: #ffffff;
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
      display: flex;
      align-items: center;
    }

    &--content-title:before {
      content: "";
      display: block;
      width: 4px;
      height: 26px;
      background: $mi-red-500;
      left: 0;
    }

    &--content-subtitle,
    &--step-subtitle {
      font-size: 14px;
      color: $mi-anthracite-800;
      max-width: 264px;
      word-break: break-word;
    }

    &--step:not(:last-child) {
      margin-right: 34px;
    }

    &--step-title {
      font-family: $mi-typography-font-family;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      text-transform: uppercase;
      color: #5b7085;
    }

    &--step-image {
      width: 264px;
      height: 157px;
      background: #f8f8f8;
      align-content: center;
      text-align-last: center;
      margin-bottom: 8px;
      margin-top: 24px;
    }

    .check-whats-new-steps {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .check-whats-new-steps-wrapper {
      display: flex;
      gap: 33px;
    }

    .check-whats-new-content {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 301px;
      height: 206px;
    }

    .check-whats-new-imgs {
      height: 155px;
      width: 300px;
      border-radius: 2px;
    }

    .check-whats-new-description {
      line-height: 21px;
      font-size: 14px;

      &--header {
        font-weight: 400;
        color: $mi-anthracite-500;
      }

      &--text {
        color: $mi-anthracite-800;
      }
    }
  }
</style>
